import apiClient from "./client";

/** Cliente do tenant (#1779): o projeto aponta para ele, e o banco do cliente é escolhido por ele. */
export interface Client {
  id: string;
  name: string;
  created_at: string;
  project_count: number;
}

export async function listClients(): Promise<Client[]> {
  const res = await apiClient.get<Client[]>("/api/clients");
  return res.data;
}

/** Nome repetido no tenant, sem olhar caixa nem espaço, volta 409. */
export async function createClient(name: string): Promise<Client> {
  const res = await apiClient.post<Client>("/api/clients", { name });
  return res.data;
}
